import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const CheckboxIcon = (props) => {
    const { icon, iconSize, iconLabelPosition, text } = props;
    const iconStyles = {
        width: `${iconSize}px`,
        height: `${iconSize}px`,
        fontSize: `${iconSize}px`,
        lineHeight: `${iconSize}px`,
    };
    return (_jsxs("span", Object.assign({ className: `checkbox-icon label-${iconLabelPosition}` }, { children: [_jsx("span", { className: `rioglyph ${icon}`, style: iconStyles }), _jsx("span", Object.assign({ className: 'checkbox-label' }, { children: text }))] })));
};
